import styled, { css } from 'styled-components';

interface Props {
  $centred?: boolean;
  $mainContent?: boolean;
}

function centredStyle({ $centred }: Props) {
  if ($centred) {
    return css`
      align-items: center;
    `;
  }
}

function mainContentStyle({ $mainContent }: Props) {
  if ($mainContent) {
    return css`
      flex: 1 0 auto;
      /* overflow-x: hidden; */
    `;
  }
}

export default styled.div<Props>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  ${centredStyle}
  ${mainContentStyle}
`;
